"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.healthOpinionImportReportSchema = exports.saglikIceAktarmaSonucSchema = exports.SAGLIK_ICE_AKTARMA_SONUCLARI = exports.KENDI_SAGLIK_VADESI_ALANLARI = exports.kendiSaglikVadesiSchema = exports.healthOpinionOptionsSchema = exports.personWorkProfileDetailSchema = exports.personWorkProfileSchema = exports.healthOpinionDetailSchema = exports.saglikVadeSuzgeciSchema = exports.SAGLIK_VADE_SUZGECLERI = exports.healthOpinionListSchema = exports.healthOpinionSummarySchema = exports.healthOpinionKisitSchema = exports.healthOpinionUpdateSchema = exports.healthOpinionCreateSchema = exports.tetkikIsaretleriSchema = exports.SAGLIK_OKUMA_SAPKALARI = exports.SAGLIK_YETKI_VARSAYILAN = exports.SAGLIK_YETKI_ANAHTARI = exports.MUAYENE_PERIYOT_TAVANI_AY = exports.MUAYENE_ASAMASI_ETIKETI = exports.muayeneAsamasiSchema = exports.MUAYENE_ASAMALARI = exports.SAGLIK_KISIT_ISARETI_ETIKETI = exports.saglikKisitIsaretiSchema = exports.SAGLIK_KISIT_ISARETLERI = exports.uygunlukKararSinifiSchema = exports.UYGUNLUK_KARAR_SINIFLARI = void 0;
exports.readKararSinifi = readKararSinifi;
exports.readBakanlikKodu = readBakanlikKodu;
exports.readEngellenenIzinTuruRefleri = readEngellenenIzinTuruRefleri;
exports.readEngellenenGorevRefleri = readEngellenenGorevRefleri;
exports.kisitIfadesi = kisitIfadesi;
exports.muayenePeriyotIhlalleri = muayenePeriyotIhlalleri;
exports.readMuayenePeriyodu = readMuayenePeriyodu;
exports.deriveKanaatBitis = deriveKanaatBitis;
exports.saglikYetkiListesiIhlali = saglikYetkiListesiIhlali;
const zod_1 = require("zod");
const shared_types_1 = require("@isg/shared-types");
const egitim_1 = require("./egitim");
const kapi_durumu_1 = require("./kapi-durumu");
/**
 * SAĞLIK GÖZETİMİ — kural katmanı (F3B·S8; Kapsam §16.11, ERD §10c;
 * tutanak `docs/arsiv/saglik-gozetimi-kararlari-v1_0.md`).
 *
 * MODÜLÜN SINIRI (S1): **sağlık verisi TUTULMUYOR, KANAAT tutuluyor.**
 * Ek-2'nin içi · bulgular · **tetkik SONUÇLARI** · tanı · reçete sisteme
 * girmez. Buradaki hiçbir tip bir tanı/tetkik değeri taşımaz ve taşıyacak
 * bir alan EKLENMEZ — `health.*` izole şeması bu modülde kullanılmaz ve
 * hazır bekler.
 *
 * İKİ TÜRETME + İKİ GUARD burada yaşar; hepsinin tek okuyucusu vardır:
 *   deriveKanaatBitis        — vade TÜRETİLİR (elle de girilebilir, S6)
 *   muayenePeriyotIhlalleri  — MEVZUAT TAVANI guard'ı (sıkılaştırılır,
 *                              gevşetilemez — 422)
 *   readKararSinifi          — kararın MAKİNE-OKUR sınıfı (§19/11-10)
 *   readEngellenen*          — kısıt → izin türü / görev eşleşmesi (§19/11-11)
 */
// ── Kural eksenleri (Kapsam §19/11-9·10·11) ─────────────────────────────────
function kuralNesnesi(kurallar) {
    return typeof kurallar === 'object' && kurallar !== null && !Array.isArray(kurallar)
        ? kurallar
        : null;
}
/**
 * Uygunluk kararının MAKİNE-OKUR sınıfı (§19/11-10). Motor kalemi **ADINDAN
 * tanıyamaz**: müşteri nüshaya çeşit ekleyebilir ve çeşidin sınıfı ANA
 * KALEMDEN miras alınır (`turetme_girdisi` deseninin sağlık kolu). Sınıfsız
 * kalem `null` döner ve serviste 422 üretir — sistem, sınıfını bilmediği
 * karara "uygundur/uygun değildir" diyemez (fail-closed).
 */
exports.UYGUNLUK_KARAR_SINIFLARI = ['uygun', 'kisitli', 'uygun_degil'];
exports.uygunlukKararSinifiSchema = zod_1.z.enum(exports.UYGUNLUK_KARAR_SINIFLARI);
function readKararSinifi(kurallar) {
    const deger = kuralNesnesi(kurallar)?.['karar_sinifi'];
    const cozum = exports.uygunlukKararSinifiSchema.safeParse(deger);
    return cozum.success ? cozum.data : null;
}
/** İBYS Bakanlık kodu — nullable ve **BOŞ dağıtılır** (J/A): değer görülmeden
 *  yazılmaz (Yönerge §5). Dışa aktarmada boş alan BOŞ çıkar. */
function readBakanlikKodu(kurallar) {
    const deger = kuralNesnesi(kurallar)?.['bakanlik_kodu'];
    return typeof deger === 'string' && deger.length > 0 ? deger : null;
}
function refListesi(kurallar, anahtar) {
    const deger = kuralNesnesi(kurallar)?.[anahtar];
    if (!Array.isArray(deger))
        return [];
    return deger.filter((ref) => typeof ref === 'string' && ref.length > 0);
}
/**
 * KISIT → İZİN TÜRÜ eşleşmesi (§19/11-11; §16.11/6 — **§19/14'ten gerekçeli
 * sapma**). Değerler izin türü kalemlerinin **KÜTÜPHANE REF'leridir**, tenant
 * nüsha id'si DEĞİL (`kok_sebep.grup_ref` deseni): nüsha dağıtımı düz kopyadır
 * ve hedef tenant'ın id uzayını bilemez, dolayısıyla kütüphaneden gelen
 * VARSAYILANIN taşıyıcısı ancak kütüphane ref'i olabilir.
 */
function readEngellenenIzinTuruRefleri(kurallar) {
    return refListesi(kurallar, 'engellenen_izin_turu_refleri');
}
/** KISIT → İZİN İÇİ GÖREV eşleşmesi (S5'in "ilgili görevler" kolu). Yetkinlik
 *  şartıyla AYNI eksen (§19/11-3): "araç/iş makinesi kullanamaz" bir izin
 *  türünü değil, izin içi bir GÖREVİ engeller. */
function readEngellenenGorevRefleri(kurallar) {
    return refListesi(kurallar, 'engellenen_gorev_refleri');
}
// ── KISIT İŞARETİ — iki yönlü kalem (GEZİNTİ ARTÇISI 3 / B7; Kapsam §16.11/14) ──
/**
 * Kanaat ↔ kısıt satırının İŞARETİ. Kalem NÖTR bir sorudur (*"yüksekte
 * çalışma"*), cevabı budur. **ÜÇÜNCÜ HÂL "SORULMAMIŞ" BİR DEĞER DEĞİLDİR** —
 * o kalem için satır yoktur; ekran boş seçeneği satır göndermeyerek yazar.
 *
 * İki okuma, tek kayıt: kanaat belgesi `kisitIfadesi` ile OLUMLU/OLUMSUZ
 * cümleyi basar; PTW uygunluk motoru (`saglikUygunMu`) yalnız `uygun_degil`
 * satırını kısıt sayar — *"aynı eksende iki kalem"* açılmaz.
 */
exports.SAGLIK_KISIT_ISARETLERI = ['uygun', 'uygun_degil'];
exports.saglikKisitIsaretiSchema = zod_1.z.enum(exports.SAGLIK_KISIT_ISARETLERI);
/** Ekran etiketi — enum token'ı ekrana çıplak çıkmaz (i18n tek kaynak). */
exports.SAGLIK_KISIT_ISARETI_ETIKETI = {
    uygun: 'Uygun',
    uygun_degil: 'Uygun değil',
};
/**
 * Kalemin BELGE CÜMLESİ — TEK OKUYUCU. Kütüphane kalemi iki ifade anahtarı
 * taşır (`ifade_uygun` / `ifade_uygun_degil`: *"Yüksekte çalışabilir"* /
 * *"Yüksekte çalışamaz"*); müşteri kalemi taşımıyorsa nötr addan
 * *"<kalem>: uygun / uygun değil"* biçimi türetilir. İkinci bir metin motoru
 * (ekranda ayrı bir cümle kurma) YAZILMAZ — PDF, liste, kişi kartı bunu okur.
 */
function kisitIfadesi(ad, kurallar, isaret) {
    const anahtar = isaret === 'uygun' ? 'ifade_uygun' : 'ifade_uygun_degil';
    const deger = kuralNesnesi(kurallar)?.[anahtar];
    if (typeof deger === 'string' && deger.trim().length > 0)
        return deger.trim();
    return `${ad}: ${exports.SAGLIK_KISIT_ISARETI_ETIKETI[isaret].toLocaleLowerCase('tr-TR')}`;
}
// ── MUAYENE AŞAMASI — TÜRETİLİR (TUR 7 / S1) ────────────────────────────────
/**
 * KAYDIN AŞAMASI: *işe giriş* mi *periyodik* mi.
 *
 * ⚠️ **BU BİR TÜR DEĞİL, BİR SIRA BİLGİSİDİR** ve **KOLON DEĞİLDİR**
 * (`equipment.son_kontrol` · `olayKapaliMi` · *"eksik"* damgası ailesi).
 * Ürün sahibi kararı (04.09.2026): *işe giriş* ve *periyodik* ayrı TÜR
 * değildir — aynı kalemdir; fark, kişinin **o işyerindeki** kaçıncı kaydı
 * olduğudur. Geçerlilik ikisinde de aynıdır (tehlike sınıfı ekseni), yani
 * ayrım hiçbir kuralı beslemiyordu ama her kayıtta bir seçim yaptırıyordu.
 *
 * ⚠️ **EKSEN (kişi, İŞYERİ)dir, yalnız kişi değil:** holding içinde başka
 * işyerine geçen kişi orada YENİDEN işe girmiştir; kanaat kişiye asılı
 * olsa da (S3) *"işe giriş"* sıfatı işyerine göredir.
 */
exports.MUAYENE_ASAMALARI = ['ise_giris', 'periyodik'];
exports.muayeneAsamasiSchema = zod_1.z.enum(exports.MUAYENE_ASAMALARI);
exports.MUAYENE_ASAMASI_ETIKETI = {
    ise_giris: 'İşe giriş',
    periyodik: 'Periyodik',
};
// ── Muayene periyodu — MEVZUAT TAVANI (S6) ──────────────────────────────────
/**
 * Muayene tekrar aralığı: çok tehlikeli **1 yıl** · tehlikeli **3 yıl** ·
 * az tehlikeli **5 yıl** (Kapsam §16.11/7). Birim AY (`gecerlilik_ay` tek
 * biçimi — §19/11-1; `+n month` aritmetiği artık yıl kaydırmaz).
 *
 * Bu bir **TAVANDIR**: müşteri daha sık muayene isteyebilir (sıkılaştırma),
 * daha seyrek İSTEYEMEZ. Ders saati asgarilerinin TERS yöndeki ikizi.
 */
exports.MUAYENE_PERIYOT_TAVANI_AY = {
    az: 60,
    tehlikeli: 36,
    cok: 12,
};
/**
 * MEVZUAT TAVANI GUARD'I (422 — kural ihlali, yetki değil). Tavanı aşan
 * periyot yazılırsa sistem mevzuatın izin verdiğinden GEÇ bir vade hesaplar
 * ve süresi dolmuş kişiyi "uygun" gösterir: **sessiz uygunluk hatası**
 * (`belge` sınıfına periyot yazma yasağının kardeşi).
 *
 * Dönüş: ihlal mesajları (boş dizi = kural tamam). Periyot HİÇ yoksa ihlal
 * yoktur — o hâlde vade türetilemez ve kayıt bitişi elle ister (S6).
 */
function muayenePeriyotIhlalleri(kurallar) {
    const nesne = kuralNesnesi(kurallar);
    const deger = nesne?.['gecerlilik_ay'];
    if (deger === undefined || deger === null)
        return [];
    const cozum = tehlikeSinifiHaritasi.safeParse(deger);
    if (!cozum.success) {
        return ['Muayene periyodu {az, tehlikeli, cok} biçiminde AY olarak yazılır (§19/11-1)'];
    }
    const ihlaller = [];
    for (const anahtar of ['az', 'tehlikeli', 'cok']) {
        const tavan = exports.MUAYENE_PERIYOT_TAVANI_AY[anahtar];
        if (cozum.data[anahtar] > tavan) {
            ihlaller.push(`Muayene periyodu mevzuat tavanını aşıyor (${anahtar}: ${cozum.data[anahtar]} ay > ` +
                `${tavan} ay) — müşteri SIKILAŞTIRABİLİR, gevşetemez`);
        }
        if (cozum.data[anahtar] < 1) {
            ihlaller.push(`Muayene periyodu en az 1 ay olmalıdır (${anahtar})`);
        }
    }
    return ihlaller;
}
const tehlikeSinifiHaritasi = zod_1.z.object({
    az: zod_1.z.number().int().positive(),
    tehlikeli: zod_1.z.number().int().positive(),
    cok: zod_1.z.number().int().positive(),
});
/** Kural setinden periyot okur; yoksa/bozuksa null (davranış düşmez —
 *  `readUyariEsigiGun` deseni). */
function readMuayenePeriyodu(kurallar) {
    const cozum = tehlikeSinifiHaritasi.safeParse(kuralNesnesi(kurallar)?.['gecerlilik_ay']);
    return cozum.success ? cozum.data : null;
}
/** Tarih aritmetiği UTC gün ekseninde (`deriveSonrakiKontrol` /
 *  `deriveYetkinlikBitis` ile AYNI eksen — ay sonu taşması yok). */
function ayEkle(tarih, ay) {
    const gun = new Date(Date.UTC(tarih.getUTCFullYear(), tarih.getUTCMonth(), tarih.getUTCDate(), 0, 0, 0, 0));
    const hedefGun = gun.getUTCDate();
    gun.setUTCMonth(gun.getUTCMonth() + ay);
    if (gun.getUTCDate() !== hedefGun)
        gun.setUTCDate(0);
    return gun;
}
/**
 * KANAAT VADESİ TÜRETİLİR (S6): muayene tarihi + periyot[tehlike sınıfı].
 * `deriveSonrakiKontrol` / `deriveYetkinlikBitis` ailesinin sağlık üyesi.
 *
 * **Ama elle de girilebilir** (S1/S6 — rapor kendi tarihini taşır): servis,
 * girdi verilmişse onu yazar; verilmemişse BUNU çağırır. Türetilemiyorsa
 * `null` döner ve servis 422 verir — **vadesiz kanaat YOKTUR** (fail-closed:
 * sistem, ne zaman biteceğini bilmediği kanaate "geçerli" diyemez).
 */
function deriveKanaatBitis(girdi) {
    if (!girdi.periyot || !girdi.tehlikeSinifi)
        return null;
    return ayEkle(girdi.muayeneTarihi, girdi.periyot[(0, egitim_1.tehlikeSinifiAnahtari)(girdi.tehlikeSinifi)]);
}
// ── Tenant yetki listesi (U6 ilkesinin ÜÇÜNCÜ uygulaması — S2) ──────────────
/**
 * `saglik_kanaat_giris` — kanaat kaydı/düzeltme, ek yönetimi, çalışma profili
 * ve dışa aktarma yetkisini taşıyan **TEK anahtar** (Kapsam §16.11/3 + §20.5).
 * Yerleşim `tenant_setting`; yeni tablo YOK.
 */
exports.SAGLIK_YETKI_ANAHTARI = 'saglik_kanaat_giris';
/**
 * VARSAYILAN (S2): **hekim + YSP + İSG uzmanı.** Olay/eğitim varsayılanından
 * FARKLIDIR ve bu bilinçlidir — kanaat girişi bir sağlık işidir; teknisyen ve
 * yöneticiler listeye ürün sahibi kararıyla eklenir (tenant yapılandırması).
 * **Boş/bozuk liste = varsayılan geçerli** (c1 — kayıt kaybı 422'den pahalı).
 *
 * **Hekim şapkası İLK KEZ gerçek bir uca bağlanır** ve bu "bağlanabilir"
 * demektir, ZORUNLU değil: hekimin sisteme girmediği müşteride uzman imzalı
 * kağıttan aktarır ve modül yine çalışır (bu yüzden kayıtta hekim referansı
 * ile GİREN KULLANICI ayrı alanlardır).
 */
exports.SAGLIK_YETKI_VARSAYILAN = ['physician', 'ysp', 'isg_specialist'];
/**
 * TABAN KİLİTLER — hiçbir tenant yapılandırması aşamaz: `viewer` hiçbir yazma
 * listesine giremez (salt-okunur genel kural); `contractor_rep` sağlık
 * listesine giremez (kanaat İÇ kullanıcı kaydıdır ve temsilci sağlık
 * kanaatini OKUYAMAZ bile — §16.11/10).
 */
function saglikYetkiListesiIhlali(liste) {
    for (const sapka of liste) {
        if (!shared_types_1.ROLE_TYPES.includes(sapka)) {
            return `Tanınmayan şapka: ${sapka}`;
        }
        if (sapka === 'viewer') {
            return 'İzleyici hiçbir yazma listesine eklenemez (salt-okunur genel kural)';
        }
        if (sapka === 'contractor_rep') {
            return ('Yüklenici temsilcisi sağlık kanaati listesine eklenemez — kanaat İÇ ' +
                'kullanıcı kaydıdır ve temsilci sağlık kanaatini okuyamaz (§16.11/10)');
        }
    }
    return null;
}
/**
 * SAĞLIK KANAATİNİ OKUYABİLEN ŞAPKALAR (✅ I — Kapsam §16.11/10).
 *
 * **GENEL GET KURALININ İSTİSNASI:** izleyici (`viewer`) holding genelini
 * salt-okunur görür — **sağlık kanaati HARİÇ**; saha sorumlusu
 * (`area_supervisor`) da dışarıdadır: *izin açarken sistem zaten engeller,
 * yani bilgiye erişmeden korunur.* Çalışan ve yüklenici temsilcisi de görmez.
 *
 * Bu liste **SABİTTİR** (tenant yapılandırması DEĞİL — "NE" tarafı): kimin
 * okuyacağı bir prosedür tercihi değil, sağlık verisi izolasyonunun sınırıdır.
 * Genişletmek ÜRÜN kararıdır ve envanter testi bunu kilitler.
 */
exports.SAGLIK_OKUMA_SAPKALARI = [
    'holding_admin',
    'physician',
    'ysp',
    'isg_specialist',
    'isg_technician',
    'company_admin',
    'location_manager',
];
// ── API sözleşmeleri ────────────────────────────────────────────────────────
/** Beş tetkik İŞARETİ (J/B) — **"yapıldı mı" bilgisi, SONUÇ DEĞİL.** Buraya
 *  değer/sonuç alanı EKLEME: S1 sınırı tam olarak burada durur. */
exports.tetkikIsaretleriSchema = zod_1.z.object({
    rontgen: zod_1.z.boolean().default(false),
    isitme: zod_1.z.boolean().default(false),
    sft: zod_1.z.boolean().default(false),
    kan: zod_1.z.boolean().default(false),
    idrar: zod_1.z.boolean().default(false),
});
const kanaatGovdesi = {
    workplaceId: zod_1.z.uuid(),
    gorevMetni: zod_1.z.string().max(300).nullish(),
    muayeneTuruRefId: zod_1.z.uuid(),
    muayeneTarihi: zod_1.z.iso.date(),
    /** Verilmezse periyottan TÜRETİLİR (S6). */
    gecerlilikBitis: zod_1.z.iso.date().nullish(),
    uygunlukKarariRefId: zod_1.z.uuid(),
    /** Hekim İÇ kişi referansı XOR DIŞ ad — ikisi de boş olabilir (kağıtta
     *  kalmış eski kayıt); ikisi birlikte 422 (`training_session` deseni). */
    hekimPersonId: zod_1.z.uuid().nullish(),
    hekimAd: zod_1.z.string().max(200).nullish(),
    /**
     * B7 — kalem başına İŞARET. Gönderilen liste TAM listedir (sorulmamış kalem
     * listede YOKTUR); aynı kalem iki kez gelirse 422 (serviste).
     */
    kisitler: zod_1.z
        .array(zod_1.z.object({ kisitRefId: zod_1.z.uuid(), isaret: exports.saglikKisitIsaretiSchema }))
        .default([]),
    tetkikler: exports.tetkikIsaretleriSchema.optional(),
    notlar: zod_1.z.string().max(2000).nullish(),
};
exports.healthOpinionCreateSchema = zod_1.z.object({
    personId: zod_1.z.uuid(),
    ...kanaatGovdesi,
});
/** Düzeltme — kişi DEĞİŞMEZ (kaydın kimliği). Yanlış kişiye girilmişse kayıt
 *  silinir, yenisi açılır (eğitim kaydının tür/işyeri kilidiyle aynı sınıf). */
exports.healthOpinionUpdateSchema = zod_1.z.object(kanaatGovdesi);
exports.healthOpinionKisitSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    /** Kalemin NÖTR adı (*"Yüksekte çalışma"*). */
    ad: zod_1.z.string(),
    kutuphaneRef: zod_1.z.string().nullable(),
    /** B7 — hekimin cevabı; sorulmamış kalem listede YOKTUR. */
    isaret: exports.saglikKisitIsaretiSchema,
    /** Belge/ekran cümlesi — `kisitIfadesi` (tek okuyucu) API kenarında türetir. */
    ifade: zod_1.z.string(),
});
exports.healthOpinionSummarySchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    personId: zod_1.z.uuid(),
    personAd: zod_1.z.string(),
    workplaceId: zod_1.z.uuid(),
    workplaceAd: zod_1.z.string(),
    muayeneTuru: zod_1.z.string(),
    /** TÜRETİLMİŞ aşama — kolon DEĞİL (S1). */
    muayeneAsamasi: exports.muayeneAsamasiSchema,
    muayeneTarihi: zod_1.z.iso.date(),
    gecerlilikBitis: zod_1.z.iso.date(),
    uygunlukKarari: zod_1.z.string(),
    kararSinifi: exports.uygunlukKararSinifiSchema.nullable(),
    kisitlar: zod_1.z.array(exports.healthOpinionKisitSchema),
    /** TÜRETİLMİŞ işaret — kolon DEĞİL (`kazaDosyasiEksikMi` deseni). */
    vadesiDoldu: zod_1.z.boolean(),
    /**
     * P6 — **BELGESİZ KANAAT** işareti; TÜRETİLİR (canlı eki var mı), kolon
     * DEĞİL. Toplu aktarma dosya taşımaz, ama okuyucunun sorusu *"nasıl
     * girildi"* değil **"belgesi var mı"**dır — elle açılmış belgesiz kayıt da
     * aynı cevabı hak eder.
     */
    belgesiz: zod_1.z.boolean(),
    gunKaldi: zod_1.z.number().int(),
});
/**
 * SAYFALI LİSTE (P1 — sayfa sözleşmesi P4; ekipman Y3 / yüklenici Y1 deseni).
 *
 * ⚠️ **`vade` TÜRETİLMİŞ SÜZGEÇTİR — sorguda koşamaz** (`vadesiDoldu` ve
 * `gunKaldi` kolon değil, türetme). Bu yüzden süzülür ve **toplam süzgeçten
 * SONRA sayılır**; sorguda sayıp bellekte süzmek sayfalamayı ve toplamı
 * BİRLİKTE yalancı yapardı (görevlendirme B3 dersi).
 *
 * ⚠️ **`uyariEsigiGun` SUNUCUDAN GELİR** (K7 marj dersinin sağlık kolu):
 * ekranda `30` sabiti yaşamaz — eşik `resolveUyariEsigi`nin okuduğu değerdir
 * ve tenant ayarıyla değişebilir.
 */
exports.healthOpinionListSchema = zod_1.z.object({
    satirlar: zod_1.z.array(exports.healthOpinionSummarySchema),
    toplam: zod_1.z.number().int(),
    sayfa: zod_1.z.number().int(),
    sayfaBoyutu: zod_1.z.number().int(),
    uyariEsigiGun: zod_1.z.number().int(),
});
/** Liste süzgecinin tanınan vade değerleri — tanınmayan değer 400. */
exports.SAGLIK_VADE_SUZGECLERI = ['dolmus', 'yaklasan'];
exports.saglikVadeSuzgeciSchema = zod_1.z.enum(exports.SAGLIK_VADE_SUZGECLERI);
exports.healthOpinionDetailSchema = exports.healthOpinionSummarySchema.extend({
    gorevMetni: zod_1.z.string().nullable(),
    hekimAd: zod_1.z.string().nullable(),
    hekimPersonAd: zod_1.z.string().nullable(),
    girenKullanici: zod_1.z.string().nullable(),
    tetkikler: exports.tetkikIsaretleriSchema,
    notlar: zod_1.z.string().nullable(),
    ekler: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        dosyaAdi: zod_1.z.string(),
        mimeType: zod_1.z.string(),
        boyutBytes: zod_1.z.number().int(),
        createdAt: zod_1.z.string(),
        /** P5 — belge SİSTEM tarafından mı ÜRETİLDİ, dışarıdan mı YÜKLENDİ. */
        kaynak: zod_1.z.enum(['uretilmis', 'yuklenmis']),
    })),
    yetkiler: zod_1.z.object({
        duzenleyebilir: zod_1.z.boolean(),
        /** P13 — kanaat yazma kapısı (tenant `saglik_kanaat_giris` listesi → bahçe) + sebep. */
        yazmaKapisi: kapi_durumu_1.kapiDurumuSchema,
    }),
});
/**
 * İBYS ÇALIŞAN ÇALIŞMA PROFİLİ (J/C) — **alanların HEPSİ nullable, KOD
 * LİSTELERİ İNMEZ.** ISCO ve Bakanlık sınıf listeleri binlerce kalem;
 * entegratörlük (madde 30, Faz 5) gelmeden faydası yok. Şema hazır durur →
 * veri göçü riski küçülür. Bu alanlara enum/lookup BAĞLAMA — karar budur.
 */
exports.personWorkProfileSchema = zod_1.z.object({
    meslekKodu: zod_1.z.string().max(50).nullish(),
    maruziyetFizikiOrtam: zod_1.z.string().max(100).nullish(),
    maruziyetHava: zod_1.z.string().max(100).nullish(),
    maruziyetGurultu: zod_1.z.string().max(100).nullish(),
    maruziyetElektrik: zod_1.z.string().max(100).nullish(),
    maruziyetToz: zod_1.z.string().max(100).nullish(),
    maruziyetKimyasal: zod_1.z.string().max(100).nullish(),
    maruziyetBiyolojik: zod_1.z.string().max(100).nullish(),
    calismaPozisyonu: zod_1.z.string().max(100).nullish(),
    calismaZamani: zod_1.z.string().max(100).nullish(),
    aracKullanimi: zod_1.z.string().max(100).nullish(),
    equipmentIds: zod_1.z.array(zod_1.z.uuid()).default([]),
});
exports.personWorkProfileDetailSchema = exports.personWorkProfileSchema.extend({
    personId: zod_1.z.uuid(),
    equipmentIds: zod_1.z.array(zod_1.z.uuid()),
    /**
     * P13 · B3 — profili YAZMA kapısı (tenant `saglik_kanaat_giris` listesi) +
     * sebep. Okuma listesindeki her şapka formu GÖRÜR; yazamayan salt okunur.
     */
    yetkiler: zod_1.z.object({ yazmaKapisi: kapi_durumu_1.kapiDurumuSchema }),
});
// ⚠️ **`ilkYardimciOraniSchema` SÖKÜLDÜ (TUR 8 / A1).** *"Bu işyerinde kaç
// ilkyardımcı var"* sorusunun tek cevabı artık görevlendirme sayımıdır
// (`isyeriZorunluGorevlendirmelerSchema` — üç sayı: gereken ·
// görevlendirilmiş · yeterli). Yetkinlikten sayan ikinci motor, ekranda
// birincinin yanında duruyordu ve ikisi farklı sayı söyleyebiliyordu.
/** Kanaat formunun havuzları — TEK okuma ucu (PTW/olay/eğitim `options`
 *  deseni). Sözlük kalemleri `ptwSelectableLookupFilter`dan geçer. */
exports.healthOpinionOptionsSchema = zod_1.z.object({
    workplaces: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string(), companyAd: zod_1.z.string() })),
    muayeneTurleri: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string() })),
    uygunlukKararlari: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        ad: zod_1.z.string(),
        /** Ekran kısıt alanını BUNA göre açar/kapatır — ikinci kural yazmaz;
         *  sunucu guard'ı aynı sınıfı okur (§16.11/8). */
        kararSinifi: exports.uygunlukKararSinifiSchema.nullable(),
    })),
    kisitlar: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string() })),
    personeller: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), adSoyad: zod_1.z.string() })),
    kayitAcabilir: zod_1.z.boolean(),
});
// ── MADDE 10'UN DAR AÇILIŞI (F4·S1 — V2; Kapsam §16.11/10) ──────────────────
/**
 * KİŞİNİN KENDİ SAĞLIK KAYDI — **YALNIZ İKİ TARİH.**
 *
 * V2'nin okuma yüzeyi: vade bildirimi kişiye gidiyorsa ekranın 403 vermesi
 * *sistemin kendi kendine yalan söylediği bir yüzey* açardı. Açılan tek şey
 * kişinin **kendi** kaydındaki muayene ve vade tarihidir.
 *
 * ⚠️ **BU YENİ BİR ŞAPKA DEĞİL, "KENDİ KAYDI" EKSENİDİR.** Dar okuma listesi
 * (`SAGLIK_OKUMA_SAPKALARI`) DELİNMEDİ: izleyici · saha sorumlusu · yüklenici
 * temsilcisi hâlâ hiçbir başkasının kaydını görmez.
 *
 * ⚠️ **KISITLAMA API KENARINDADIR (Y5), ekran gizlemesiyle DEĞİL.** Karar ·
 * kısıt · hekim · tetkik işaretleri cevapta **boş değil, YOK** — alanlar bu
 * şemada hiç tanımlı değildir ve şema `strict`tir: birisi yanıta bir alan
 * eklerse parse DÜŞER. Alanları ekleyip ekranda saklamak, ilk ağ sekmesini
 * açana veriyi verirdi.
 */
exports.kendiSaglikVadesiSchema = zod_1.z.strictObject({
    /** Kayıt yoksa null — kişi kendi kaydının YOKLUĞUNU bilmeye hak sahibidir
     *  (eksik taramasının kişi tarafındaki karşılığı). */
    kayit: zod_1.z
        .strictObject({
        muayeneTarihi: zod_1.z.iso.date(),
        gecerlilikBitis: zod_1.z.iso.date(),
    })
        .nullable(),
});
/**
 * Dar yanıtın ALAN ENVANTERİ (`PTW_QR_OZET_ALANLARI` deseni): daralmanın
 * testi bu listeden okur. Buraya alan eklemek testi kırar ve kararın
 * açıkça verilmesini zorunlu kılar — §16.11'in sır sınırı tam burada durur.
 */
exports.KENDI_SAGLIK_VADESI_ALANLARI = ['muayeneTarihi', 'gecerlilikBitis'];
// ── P6 — GEÇMİŞ MUAYENE DURUMUNUN TOPLU AKTARIMI (TUR 7) ────────────────────
/**
 * Kurulum günü, müşterinin elindeki muayene listesini sisteme taşımanın yolu
 * (içe aktarma motorunun YEDİNCİ müşterisi).
 *
 * ⚠️ **DOSYA AKTARILMAZ.** Excel'den belge gelmez; aktarılan kayıtlar
 * **belgesiz** doğar ve bu ekranda **rozetle** görünür. ⚠️ Rozet
 * **TÜRETİLİR** (kaydın canlı eki var mı) — *"aktarma ile mi geldi"*
 * kolonu AÇILMAZ: okuyucunun sorusu *"belgesi var mı"*dır, *"nasıl
 * girildi"* değil, ve elle açılmış belgesiz bir kayıt da aynı cevabı hak
 * eder.
 *
 * ⚠️ **EŞLEŞTİRME İSİMLE, TC KOLONU YOK** (devir/eğitim deseni): sistem
 * öncesi listelerde kimlik no yoktur. **ÇOKLU eşleşmede satır REDDEDİLİR**
 * ve **SIFIR eşleşmede de** — *sağlık verisinde tahmin yürütülmez*; yanlış
 * kişiye yazılmış bir kanaat, hiç yazılmamış olandan pahalıdır.
 */
exports.SAGLIK_ICE_AKTARMA_SONUCLARI = ['eklendi', 'hata'];
exports.saglikIceAktarmaSonucSchema = zod_1.z.enum(exports.SAGLIK_ICE_AKTARMA_SONUCLARI);
exports.healthOpinionImportReportSchema = zod_1.z.object({
    toplam: zod_1.z.number().int().min(0),
    eklenen: zod_1.z.number().int().min(0),
    hatali: zod_1.z.number().int().min(0),
    satirlar: zod_1.z.array(zod_1.z.object({
        satir: zod_1.z.number().int().positive(),
        sonuc: exports.saglikIceAktarmaSonucSchema,
        /** Eklenen satırda kişinin adı; hatalı satırda null. */
        ad: zod_1.z.string().nullable(),
        opinionId: zod_1.z.uuid().nullable(),
        mesaj: zod_1.z.string().nullable(),
        uyarilar: zod_1.z.array(zod_1.z.string()),
    })),
});
//# sourceMappingURL=saglik.js.map